import { s } from '@/theme/tokens';
import { Checkbox, FormControlLabel, Text } from '@/ui/primitives';
import type { ReactElement } from 'react';

type DeltasToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const DeltasToggle = ({ checked, onChange }: DeltasToggleProps): ReactElement => (
  <FormControlLabel
    sx={{
      mr: s('none'),
      ml: s('none'),
      columnGap: s('xs'),
      alignItems: 'center',
      '& .MuiFormControlLabel-label': {
        mr: s('none'),
        display: 'flex',
        alignItems: 'center',
      },
    }}
    labelPlacement="start"
    control={
      <Checkbox
        size="small"
        checked={checked}
        onChange={(event) => {
          onChange(event.target.checked);
        }}
        sx={{ px: s('xs'), py: s('none') }}
      />
    }
    label={
      <Text role="body" component="span">
        Deltas
      </Text>
    }
  />
);
